import { create } from "zustand";

type Store = {
  isExpired: boolean;
  markExpired: () => void;
  reset: () => void;
};

/**
 * Bridges the API client's 401 handling — which runs in fetch middleware,
 * outside React — to the `SessionExpiredDialog` that renders the recovery path.
 *
 * Deliberately NOT persisted, unlike `checkout-store`: the dialog sends the user
 * through a full-page login round trip, and a persisted flag would re-open the
 * dialog when they came back and lock them out permanently.
 */
export const useSessionStore = create<Store>()((set, get) => ({
  isExpired: false,
  // Idempotent: several requests can 401 at once, and they must produce one
  // dialog, not one per request.
  markExpired: () => {
    if (get().isExpired) {
      return;
    }
    set({ isExpired: true });
  },
  reset: () => set({ isExpired: false }),
}));
